/* Bahimi theme controller: shop drawer, scroll reveals, hero-variant nav.
   Loaded on every page (layout/theme.liquid). */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    /* ---- shop drawer ---- */
    var drawer = document.querySelector('[data-bh-drawer]');
    if (drawer) {
      var panel = drawer.querySelector('[data-bh-drawer-panel]');
      var openers = document.querySelectorAll('[data-bh-drawer-open]');
      var lastFocused = null;
      var isOpen = function () { return drawer.classList.contains('bh-drawer--open'); };
      var focusables = function () {
        return panel ? panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])') : [];
      };
      var setExpanded = function (val) {
        openers.forEach(function (el) { el.setAttribute('aria-expanded', val ? 'true' : 'false'); });
      };
      var openDrawer = function (focusFirst) {
        lastFocused = document.activeElement;
        drawer.classList.add('bh-drawer--open');
        drawer.setAttribute('aria-hidden', 'false');
        setExpanded(true);
        if (focusFirst) { var f = focusables(); if (f.length) f[0].focus(); }
      };
      var closeDrawer = function () {
        var hadFocus = panel && panel.contains(document.activeElement);
        drawer.classList.remove('bh-drawer--open');
        drawer.setAttribute('aria-hidden', 'true');
        setExpanded(false);
        if (hadFocus && lastFocused && lastFocused.focus) lastFocused.focus();
      };
      openers.forEach(function (el) {
        el.addEventListener('click', function () { openDrawer(true); });
        el.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) openDrawer(false);
        });
      });
      drawer.querySelectorAll('[data-bh-drawer-close]').forEach(function (el) {
        el.addEventListener('click', closeDrawer);
      });
      if (panel) {
        panel.addEventListener('mouseleave', function () {
          if (window.matchMedia('(hover: hover)').matches) closeDrawer();
        });
      }
      /* audit #21: ESC + focus trap while the drawer is open. */
      document.addEventListener('keydown', function (e) {
        if (!isOpen()) return;
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key === 'Tab') {
          var f = focusables();
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });
    }

    /* ---- hero-variant nav: transparent until scrolled ---- */
    var heroNav = document.querySelector('[data-bh-nav-variant="hero"]');
    if (heroNav) {
      var onScroll = function () {
        heroNav.classList.toggle('bh-nav--scrolled', window.scrollY > 80);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- Dawn 16 customer-account popover positioning ---- */
    document.addEventListener('open', function (event) {
      var account = event.target;
      if (!(account instanceof HTMLElement) || !account.matches('shopify-account')) return;

      var bottom = Math.max(0, Math.round(account.getBoundingClientRect().bottom));
      account.style.setProperty('--shopify-account-dialog-position-top', bottom + 'px');
    }, true);

  });
})();
